module.exports = __webpack_public_path__ + "img/login_center.b49b3869.png";